import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { ReactNode, useState } from "react";

import TabPanel from "../TabPanel";

type TTab = {
  label: string;
  index: number;
  handleClick?: () => Promise<void>;
  children: ReactNode;
};

interface ITimelineProps {
  tabs: TTab[];
  padding?: string;
  borderBottom?: number;
  borderColor?: string;
  button?: ReactNode;
  marginTop?: number;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const Timeline = (props: ITimelineProps) => {
  const { tabs, padding, borderBottom, borderColor, button, marginTop } = props;

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box padding={padding || "24px 0px 32px 0px"}>
      <Box
        sx={{
          borderBottom: borderBottom,
          borderColor: borderColor,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
        >
          {tabs.map((tab) => (
            <Tab
              label={tab.label}
              onClick={tab.handleClick}
              sx={{
                minWidth: `${tab.label.length}px`,
                p: "8px 0px",
                marginRight: 4,
              }}
              {...a11yProps(value)}
            />
          ))}
          <Box display="flex" alignItems="center">
            {button}
          </Box>
        </Tabs>
      </Box>
      {tabs.map((tab) => (
        <Box marginTop={marginTop || 0}>
          <TabPanel index={tab.index} value={value}>
            {tab.children}
          </TabPanel>
        </Box>
      ))}
    </Box>
  );
};
